// extracted by mini-css-extract-plugin
module.exports = {"favorite-songs":"favorite-songs_favorite-songs__pkmOE"};